<template>
  <div
    v-if="isAccountIdEnabled"
    class="emd-panel__section eu-my_5"
  >
    <emd-text
      tag="h2"
      class="emd-panel__block eu-display_flex eu-align-items_center_md"
    >
      {{ $t('keys.id') }}
    </emd-text>

    <copy-clipboard
      :copiable="account.id"
      class="emd-panel__block eu-basis_4_md eu-basis_2_lg"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { EmdText } from 'emerald-vue/src/components'

import { isAccountIdEnabled } from '@/actions-permission/keys.permissions'

export default {
  name: 'VersionAPI',

  components: {
    EmdText,

    CopyClipboard: () => import('@/components/project/molecules/CopyClipboard')
  },

  computed: {
    ...mapGetters(['account', 'permissionIsEnabled']),

    isAccountIdEnabled () {
      return isAccountIdEnabled(this.permissionIsEnabled)
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "keys": {
        "id": "ID da conta"
      }
    },
    "en-US": {
      "keys": {
        "id": "Account ID"
      }
    }
  }
</i18n>
